import { render, staticRenderFns } from "./addressChangeConfirmation.vue?vue&type=template&id=c1334234&scoped=true"
import script from "./addressChangeConfirmation.vue?vue&type=script&lang=js"
export * from "./addressChangeConfirmation.vue?vue&type=script&lang=js"
import style0 from "./addressChangeConfirmation.vue?vue&type=style&index=0&id=c1334234&prod&lang=less&scoped=true"
import style1 from "./addressChangeConfirmation.vue?vue&type=style&index=1&id=c1334234&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1334234",
  null
  
)

export default component.exports